import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
import detail from '@/pages/detail'
import Car from '@/pages/details/car'
import earth from '@/pages/details/earth'
import hill from '@/pages/details/hill'
import loud from '@/pages/details/loud'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: Layout
    },
    {
      path: '/details',
      name: 'Details',
      component: detail,
      redirect:"/details/earth",
      children: [
        {
          path: 'car',
          name: 'car',
          component: Car
        },
        {
          path: 'earth',
          name: 'earth',
          component: earth
        },
        {
          path: 'hill',
          name: 'hill',
          component: hill
        },
        {
          path: 'loud',
          name: 'loud',
          component: loud
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js